module.exports = __webpack_public_path__ + "static/media/visa_logo.920a0b4c.png";